import React from 'react'

import * as Yup from 'yup'
import { Form, Input } from 'formik-antd'
import { BasicForm } from '../../../core/components/form'
import { useChangePassword } from '../../../hooks/common/user'
import { useHistory } from 'react-router-dom'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../core/utils/form'

const LoginSchema = Yup.object()
  .shape({
    current_password: Yup.string().required('Cannot be blank.'),
    password_first: Yup.string()
      .required('Cannot be blank.')
      .min(4, 'The password must be longer than 3 characters'),
    password_second: Yup.string().required('Cannot be blank.')
  })
  .test('idem', function (value) {
    if (!value) return true
    const { password_first, password_second } = value
    let valid = false
    if (password_first === password_second) {
      valid = true
    }

    return (
      valid ||
      this.createError({
        // Formik will use the error "path" as the key in the errors; set this to whatever you want
        path: 'password_first',
        message: 'The password does not match'
      })
    )
  })

const Formulario = () => {
  const update = useChangePassword()
  const history = useHistory()

  const onPressBack = () => history.goBack()

  function handleSubmit (values, bag) {
    const form = { ...values }

    update.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        onPressBack()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const initialValues = {
    current_password: '',
    password_first: '',
    password_second: ''
  }

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo='CHANGE PASSWORD'
      subtitulo='Form'
      initialValues={initialValues}
      validationSchema={LoginSchema}
      onSubmit={handleSubmit}
      render={() => (
        <>
          <Form.Item
            label='Current Password'
            name='current_password'
            hasFeedback
            showValidateSuccess
            required
          >
            <Input.Password name='current_password' placeholder='Current Password' />
          </Form.Item>
          <Form.Item
            label='Password'
            name='password_first'
            hasFeedback
            showValidateSuccess
            required
          >
            <Input.Password name='password_first' placeholder='Password' />
          </Form.Item>
          <Form.Item
            label='Repeat Password'
            name='password_second'
            hasFeedback
            showValidateSuccess
            required
          >
            <Input.Password name='password_second' placeholder='Repeat Password' />
          </Form.Item>
        </>
      )}
    />
  )
}

export default Formulario
